'use client'
import Button from '@/shared/components/button'
import Card from '@/shared/components/card'
import { Col, Row } from '@/shared/components/row'
import React, { useRef, useState } from 'react'

export default function FancyList({ fancyList }: any) {
	const isLoadMore = useRef(fancyList?.length)
	const [data, setData] = useState(fancyList?.slice(0, fancyList?.length > 20 ? 20 : -1))
	function loadMore() {
		isLoadMore.current = false
		setData(fancyList)
	}
	return (
		<>
			<Row className='gap-x-6 sm:gap-y-4'>
				{data?.map((item: any) => {
					const sFancyData = item?.title?.split('(')
					return (
						<Col
							key={item?.title}
							xs={12}
							sm={6}>
							<Card
								className='!bg-cardBg !border-tabBorder justify-between rounded-xl items-center py-4 md:py-5 px-3 md:px-4'
								defaultBordered>
								<div className=''>
									<p className='text-xs sm:text-base font-medium text-textOffWhite'>{sFancyData[0]}</p>
								</div>
								<div className='flex items-center justify-end'>
									<div className='text-xs sm:text-base font-medium w-14 text-right'>
										<p className='text-xs md:text-base text-textOffWhite'>{item?.no}</p>
										<p className='text-textRed text-xs md:text-base'>{item?.min}</p>
									</div>
									<div className='text-xs sm:text-base font-medium w-14 text-right ml-2'>
										<p className='text-xs md:text-base text-textOffWhite'>{item?.yes}</p>
										<p className='text-textGreen text-xs md:text-base'>{item?.max}</p>
									</div>
								</div>
							</Card>
						</Col>
					)
				})}
			</Row>
			{isLoadMore.current ? (
				<div className='text-center my-3'>
					<Button
						className=''
						onClick={loadMore}>
						Load More
					</Button>
				</div>
			) : null}
		</>
	)
}
